import React from 'react';
import { Image, Pressable, Text } from 'react-native';
import { RADIUS } from '../assets/theme';
import { makeStyles } from '../theme/ThemeContext';

const logo = require('../../assets/logo.jpeg');

type BrandMarkProps = {
  size?: number;
  showName?: boolean;
  onPress?: () => void;
};

/** GeoFleete logo tile + wordmark. */
export default function BrandMark({ size = 36, showName = true, onPress }: BrandMarkProps) {
  const styles = useStyles();
  return (
    <Pressable
      onPress={onPress}
      disabled={!onPress}
      accessibilityRole={onPress ? 'link' : undefined}
      accessibilityLabel="GeoFleete — accueil"
      style={styles.row}
    >
      <Image source={logo} style={[styles.logo, { width: size, height: size }]} resizeMode="cover" />
      {showName ? (
        <Text style={[styles.name, { fontSize: Math.round(size * 0.55) }]} numberOfLines={1}>
          geo<Text style={styles.nameAccent}>fleete</Text>
        </Text>
      ) : null}
    </Pressable>
  );
}

const useStyles = makeStyles((c) => ({
  row: { flexDirection: 'row', alignItems: 'center', gap: 10 },
  logo: { borderRadius: RADIUS.sm },
  name: { fontWeight: '800', color: c.brand, letterSpacing: -0.6 },
  nameAccent: { color: c.primary },
}));
